import { render, staticRenderFns } from "./LpListItem.vue?vue&type=template&id=52e7a7a2&scoped=true&"
import script from "./LpListItem.vue?vue&type=script&lang=js&"
export * from "./LpListItem.vue?vue&type=script&lang=js&"
import style0 from "./LpListItem.vue?vue&type=style&index=0&id=52e7a7a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e7a7a2",
  null
  
)

export default component.exports